import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../common/utils';
import { AddressItemFacade } from './address-item.facade';

@Injectable({
  providedIn: 'root',
})
export class AddressItemGuard  {
  constructor(private addressItemFacade: AddressItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const {
      params: { addressId },
    } = route;
    return checkStoreState(this.addressItemFacade, addressId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.addressItemFacade);
  }
}
